"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_helmet_1 = require("react-helmet");
var PaperClip_1 = __importDefault(require("../../components/PaperClip"));
var Layout_1 = require("../../components/Layout");
var styles_1 = require("./styles");
var constant_1 = require("../../constant");
var Experiences = function () {
    var _a = react_1.useState(-10), rotate = _a[0], setRotate = _a[1];
    react_1.useEffect(function () {
        var timeout1 = setTimeout(function () { return setRotate(10); }, 200);
        var timeout2 = setTimeout(function () { return setRotate(-8); }, 400);
        var timeout3 = setTimeout(function () { return setRotate(6); }, 600);
        var timeout4 = setTimeout(function () { return setRotate(-4); }, 800);
        var timeout5 = setTimeout(function () { return setRotate(3); }, 1000);
        var timeout6 = setTimeout(function () { return setRotate(-2); }, 1200);
        return function () {
            clearTimeout(timeout1);
            clearTimeout(timeout2);
            clearTimeout(timeout3);
            clearTimeout(timeout4);
            clearTimeout(timeout5);
            clearTimeout(timeout6);
        };
    }, []);
    return (react_1.default.createElement(Layout_1.BoxedContainer, null,
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement("title", null,
                "Exp\u00E9riences - ",
                constant_1.SITE_TITLE),
            react_1.default.createElement("meta", { name: "description", content: "D\u00E9couvrez le parcours de Gloria Luzio, d\u00E9veloppeuse React chez Epycure depuis 2020." }),
            react_1.default.createElement("meta", { property: "og:title", content: "Exp\u00E9riences | Gloria Luzio - d\u00E9veloppeuse Javascript React - Paris" }),
            react_1.default.createElement("meta", { property: "og:description", content: "D\u00E9couvrez le parcours de Gloria Luzio, d\u00E9veloppeuse React chez Epycure depuis 2020." }),
            react_1.default.createElement("meta", { property: "og:url", content: "https://www.glorialuzio.fr/experiences" })),
        react_1.default.createElement(styles_1.BlackBoard, null,
            react_1.default.createElement(styles_1.Pin, null),
            react_1.default.createElement("div", null,
                react_1.default.createElement(styles_1.ExperienceStyled, null,
                    react_1.default.createElement(styles_1.HorizontalBorder, null),
                    react_1.default.createElement(styles_1.ExperienceTitle, { rotate: rotate },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(PaperClip_1.default, null)),
                        "2 juin 2020 \u00E0 aujourd'hui : D\u00E9veloppeuse front-end - Epycure - Paris"),
                    react_1.default.createElement(styles_1.ExperienceResume, null,
                        "Refonte totale du site Epycure en React/ Gatsby/ TypeScript.",
                        react_1.default.createElement("br", null),
                        "D\u00E9veloppement de la page d'accueil, du shop, des pages produits, blog, pages ingr\u00E9dients, experts, objectfis, FAQ, page r\u00E9sultat.")),
                react_1.default.createElement(styles_1.ExperienceStyled, null,
                    react_1.default.createElement(styles_1.HorizontalBorder, null),
                    react_1.default.createElement(styles_1.ExperienceTitle, { rotate: rotate },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(PaperClip_1.default, null)),
                        "2 au 13 mars 2020 : D\u00E9veloppeuse front-end - AKO - Paris"),
                    react_1.default.createElement(styles_1.ExperienceResume, null,
                        "D\u00E9veloppement de l'application AKO, dans le cadre d'un Produit Minimum Viable, en partenariat avec Koudetat/The Family. ",
                        react_1.default.createElement("br", null),
                        "Cette application a pour but le partage de connaissances.")),
                react_1.default.createElement(styles_1.ExperienceStyled, null,
                    react_1.default.createElement(styles_1.HorizontalBorder, null),
                    react_1.default.createElement(styles_1.ExperienceTitle, { rotate: rotate },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(PaperClip_1.default, null)),
                        "Janvier - Mars 2020 : Formation d\u00E9veloppeur web et mobile \u00E0 Le Reacteur - Paris"),
                    react_1.default.createElement(styles_1.ExperienceResume, null,
                        "J'ai suivi cette formation intensive, ax\u00E9e sur React/React Native, dans le cadre d'une reconversion professionnelle. ",
                        react_1.default.createElement("br", null),
                        "Durant cette formation j'ai pu r\u00E9aliser plusieurs projets aussi bien front-end que back-end.")),
                react_1.default.createElement(styles_1.ExperienceStyled, null,
                    react_1.default.createElement(styles_1.HorizontalBorder, null),
                    react_1.default.createElement(styles_1.ExperienceTitle, { rotate: rotate },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(PaperClip_1.default, null)),
                        "Ao\u00FBt 2014 - Janvier 2020 : Infirmi\u00E8re \u00E0 l'h\u00F4pital Robert Debr\u00E9 - Paris"),
                    react_1.default.createElement(styles_1.ExperienceResume, null, "Durant ces ann\u00E9es d'exercice je n'ai pas tap\u00E9 une ligne de code. J'y ai en revanche appris le travail en \u00E9quipe, l'autonomie et la rigueur. J'ai \u00E9galement pu am\u00E9liorer mon relationnel. Enfin, j'ai \u00E9galement d\u00FB apprendre \u00E0 g\u00E9rer mon stress dans ce m\u00E9tier qui ne laisse pas sa place \u00E0 l'erreur."))))));
};
exports.default = Experiences;
